const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a1324dfd254d1ef23e297031af78c35a167b64c9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["district-web-vercel-dev@districtweb"]={id:"a1324dfd254d1ef23e297031af78c35a167b64c9"};
      